import { Alert, Card, CardContent, Stack, Typography } from '@mui/material';
import { FunctionComponent, PropsWithChildren } from 'react';
import { BackgroundLogo } from '../BackgroundLogo';
import { InlineErrorAlert } from '../InlineErrorAlert';
import { LoadingOverlay } from '../LoadingOverlay';

type Props = PropsWithChildren<{
	title: string;
	subtitle?: string;
	loading: boolean;
	loadingLabel?: string;
	error?: string | undefined;
	success?: string | undefined;
}>;

export const AuthLayout: FunctionComponent<Props> = (props) => {
	return <Stack sx={{
		alignItems: 'center',
		justifyContent: 'center',
		minHeight: '100vh',
		padding: 3,
		backgroundColor: 'background.default',
	}}
	>
		<LoadingOverlay loading={props.loading} label={`${props.loadingLabel ?? 'Loading'}`} />
		<BackgroundLogo />

		<Card sx={{ maxWidth: 'sm', width: '100%', zIndex: 10 }}>
			<CardContent sx={{ padding: 4 }}>
				<Typography variant="h4" component="h1" gutterBottom align="center">
					{props.title}
				</Typography>

				{props.subtitle &&
					<Typography variant="body2" color="text.secondary" align="center" sx={{ marginBottom: 3 }}>
						{props.subtitle}
					</Typography>}

				<InlineErrorAlert error={props.error} />

				{props.success &&
					<Alert severity="success" sx={{ marginBottom: 2 }}>
						{props.success}
					</Alert>}

				{props.children}
			</CardContent>
		</Card>
	</Stack>;
};
